export default __webpack_public_path__ + "static/media/bulb.2ac011db.png";